import React from 'react'
import { useSelector } from 'react-redux'

import { getSession } from '../../store/auth'
import { withSTKExpirationGuard } from './withSTKExpirationGuard'
import { Loader } from '../shared/LazyLoadingProvider'

const SessionProvider = ({ children }) => {
  const session = useSelector(getSession)

  if (session.status === 'loading') {
    return <Loader />
  }

  if (session.status !== 'loaded') {
    return null
  }

  return children
}

export default withSTKExpirationGuard(SessionProvider)
